import { ArrowRightOutlined } from "@ant-design/icons";
import { Button, Card, Col, Modal, Row, Tabs } from "antd";
import dateFormat from "dateformat";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { calculateDuration } from "../../../common/AllTickets/Flight/flightHelper";

import "./Flightticketsuccess.scss";
import moment from "moment";

const { TabPane } = Tabs;
const Flightticketsuccess = ({ flightTicketsDetails, ticketData }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [detailsModal, setDetailsModal] = useState({});
  const [bookingStatus, setBookingStatus] = useState('');

  const handleDetailsModal = (flightDetails) => {
    setDetailsModal(flightDetails);
    setIsVisible(true);
  };

  const handleModalClose = () => {
    setIsVisible(false);
    setDetailsModal({});
  };

  const formatFlightTime = (flightTime) => {
    let [date, time] = flightTime.split("T");
    let [hour, minute, seconds] = time.split(":");
    return `${hour}:${minute}`;
  };

 useEffect(() => {
    if (flightTicketsDetails && flightTicketsDetails.ticketAllData) {
      const status = flightTicketsDetails.ticketAllData?.BookingStatus?.trim()?.toLowerCase();
      setBookingStatus(status);
    }
  }, [flightTicketsDetails]);

  return (
    <div className="promo providerapi">
      <div className="ourteam-bg">
        <div className="admin-container cms-pages-width retrieve-linebar">
          <Card className="retrieve-booking busmtb">
            <h4 className="ticket-lti">Flight ltinerary</h4>
            <Row>
              {flightTicketsDetails.flightDetails.length > 0 ? (
                <>
                  <Col md={12} xs={24}>
                    {flightTicketsDetails.flightDetails.map(
                      (flightDetails, i) => (
                        <>
                          <h6 className="type">
                            {i === 0 ? "Onward:" : "Return:"}
                          </h6>
                          <div className="fic-tickets-data">
                            <Row gutter={8}>
                              <Col md={12} xs={24}>
                                <div className="tic-indi-details">
                                  <p>
                                    {flightDetails.flightSegments.length > 0
                                      ? flightDetails.flightSegments[0].origin
                                      : ""}
                                  </p>

                                  <span className="airline-tic-files"></span>
                                  {flightDetails.flightSegments.map(
                                    (segment, index) =>
                                      index !== 0 ? (
                                        <>
                                          <p>{segment.origin}</p>
                                          <span className="airline-tic-files"></span>
                                        </>
                                      ) : null
                                  )}

                                  <p>
                                    {flightDetails.flightSegments.length > 0
                                      ? flightDetails.flightSegments[
                                          flightDetails.flightSegments.length -
                                            1
                                        ].destination
                                      : ""}
                                  </p>
                                </div>
                              </Col>
                              <Col md={6} xs={24}>
                                <div className="plane-retrive-data">
                                  <ul>
                                    <li>
                                      <p>
                                        {flightDetails.flightSegments.length > 0
                                          ? formatFlightTime(
                                              flightDetails.flightSegments[0]
                                                .departureDateTime
                                            )
                                          : ""}
                                      </p>
                                    </li>

                                    <li>
                                      <ArrowRightOutlined />
                                    </li>

                                    <li>
                                      {flightDetails.flightSegments.length >
                                      0 ? (
                                        <p>
                                          {formatFlightTime(
                                            flightDetails.flightSegments[
                                              flightDetails.flightSegments
                                                .length - 1
                                            ].arrivalDateTime
                                          )}
                                        </p>
                                      ) : (
                                        ""
                                      )}
                                    </li>
                                  </ul>
                                </div>
                              </Col>
                            </Row>
                          </div>

                          {/* sub--secondrow--start */}

                          <div className="trip-advise-de">
                            <div className="flight-retrive-value">
                              <div className="plane-retrive-data">
                                <span>
                                  {flightDetails.flightSegments.length > 0
                                    ? dateFormat(
                                        flightDetails.flightSegments[0]
                                          .departureDateTime,
                                        "dd mmm (ddd)"
                                      )
                                    : ""}
                                </span>
                                {/* <ul>
                                          <li>
                                            <p>
                                              {flightDetails.flightSegments
                                                .length > 0
                                                ? formatFlightTime(
                                                    flightDetails
                                                      .flightSegments[0]
                                                      .departureDateTime
                                                  )
                                                : ""}
                                            </p>
                                          </li>

                                          <li>
                                            <ArrowRightOutlined />
                                          </li>

                                          <li>
                                            {flightDetails.flightSegments
                                              .length > 0 ? (
                                              <p>
                                                {formatFlightTime(
                                                  flightDetails.flightSegments[
                                                    flightDetails.flightSegments
                                                      .length - 1
                                                  ].arrivalDateTime
                                                )}
                                              </p>
                                            ) : (
                                              ""
                                            )}
                                          </li>
                                        </ul> */}
                              </div>
                              {/* plane--retrive--close */}

                              {/* <div className="travel-time-data-info">
                                        <p>
                                          <ClockCircleOutlined />
                                        </p>
                                        {flightDetails.flightSegments.length >
                                        0 ? (
                                          <p>
                                            {calculateDuration(
                                              flightDetails.flightSegments[0]
                                                .departureDateTime,
                                              flightDetails.flightSegments[
                                                flightDetails.flightSegments
                                                  .length - 1
                                              ].arrivalDateTime
                                            )}
                                          </p>
                                        ) : (
                                          ""
                                        )}
                                      </div> */}
                              {/* travel--daata--info */}

                              <div className="infomail-time-data-info">
                                <p>
                                  {flightDetails.flightSegments.length === 1 ? (
                                    "Direct"
                                  ) : (
                                    <>
                                      {flightDetails.flightSegments.length - 1}{" "}
                                      stops
                                    </>
                                  )}
                                </p>
                              </div>
                              <div className="infomail-time-data-info">
                                <p>PNR: {flightDetails.pnr}</p>
                              </div>

                              {/* <div className="details-fli-one">
                                        <p
                                          onClick={() =>
                                            handleDetailsModal(flightDetails)
                                          }
                                        >
                                          Details
                                        </p>
                                      </div> */}
                            </div>
                          </div>
                        </>
                      )
                    )}
                  </Col>

                  <Col md={12} xs={24} className="flight-email-dd">
                    {/* <div className="paymet-booking-tic">
                      <h4>Ticket Booking Payment Successful</h4>
                      <p>
                        A confirmation email has been sent your provided email
                        address
                      </p>
                      <p>Ref-No : {flightTicketsDetails.BookingRefNo}</p>
                      <p>
                        Status :{" "}
                        <span className="succes-pay-value">
                          {flightTicketsDetails.ticketAllData.BookingStatus}
                        </span>
                      </p>
                       {console.log(flightTicketsDetails)} 
                    </div> */}
                    <div className="paymet-booking-tic">
                      {bookingStatus === "hold" ? (
                        <>
                          <h4>Your Ticket is on Hold</h4>
                          <pre className="paymet-booking-tic">Last Ticketing Date:{moment(flightTicketsDetails?.flightDetails[0]?.tktTimeLimit).format("DD-MM-YYYY")} | IST {moment(flightTicketsDetails?.flightDetails[0]?.tktTimeLimit).format("HH:mm")} Hours</pre>
                          <p>A Hold ticket has been sent to your provided email address</p>
                        </>
                      ) : (
                        <>
                          <h4>Ticket Booking Payment Successful</h4>
                          <p>A confirmation email has been sent to your provided email address</p>
                        </>
                      )}
                      <p>Ref-No : {flightTicketsDetails.BookingRefNo}</p>
                      <p>
                        Status :{" "}
                        <span className="succes-pay-value">
                          {flightTicketsDetails.ticketAllData.BookingStatus}
                        </span>
                      </p>
                    </div>

                    <Row>
                      <Col md={12} xs={24}>
                        <Button className="tic-retrive-book" htmlType="submit">
                          <Link
                            to={`flight/ticket?ref=${flightTicketsDetails.BookingRefNo}`}
                          >
                            Retrieve Booking
                          </Link>
                        </Button>
                      </Col>
                      <Col md={12} xs={24}></Col>
                    </Row>
                  </Col>
                </>
              ) : (
                <Col lg={24} md={24} sm={24} xs={24}>
                  <p className="mb-0">
                    <strong>
                    Message :  Booking is on hold please don't try to book the ticket as our backend team is working on this ticket, please allow us 30 minutes to confirm the same, if you don't receive any confirmation within 30 minutes please call us on this number
                      <table style={{'color':'red'}}>
                        <tr>
                          <td> 011 4951 13 13</td>
                          <td> ( 10 am - 7:00 pm ) </td>
                        </tr>
                        <tr>
                          <td> + 91 9999442804</td>
                          <td>  ( 07:00 pm - 12:00 am )  </td>
                        </tr>
                        <tr>
                          <td> +91 916686 883 7 </td>
                          <td>( 07:00 pm - 12:00 am )  </td>
                        </tr>
                        <tr>
                          <td> +91 9958690805</td>
                          <td>  ( 07:00 pm - 12:00 am )  </td>
                        </tr>
                        </table>
                        Email us at - tickets@shopyourtrip.com
                      {/* {flightTic
                        ketsDetails.otherMessage} */}
                      </strong>
                  </p>
                  {flightTicketsDetails.errorMessage && (
                    <p className="mb-0">
                      <strong>
                        Message :  Booking is on hold please don't try to book the ticket as our backend team is working on this ticket, please allow us 30 minutes to confirm the same, if you don't receive any confirmation within 30 minutes please call us on this number 9166868837/9999442804
                        {/* {flightTicketsDetails.errorMessage} */}
                      </strong>
                    </p>
                  )}
                </Col>
              )}
            </Row>
          </Card>

          <Modal
            className="modal-fl-heading"
            title="Flight Details"
            visible={isVisible}
            footer={[null]}
            onOk={handleModalClose}
            onCancel={handleModalClose}
        //    className="flight-details-modal"
          >
            <div className="all-times-local">
              <Tabs
                defaultActiveKey="1"
                // onTabClick={(str, e) => fetchFlightFares(str, e)}
              >
                {Object.keys(detailsModal).length > 0 ? (
                  <TabPane tab="Segments" key="1">
                    <div className="from-to-modal-details">
                      <Row gutter={16} className="more-details-row">
                        <Col span={14}>
                          <Row gutter={16}>
                            <Col span={8} className="more-details-list">
                              <p>{detailsModal.flightSegments[0].origin}</p>
                              <p>
                                <strong>
                                  {dateFormat(
                                    detailsModal.flightSegments[0]
                                      .departureDateTime,
                                    "HH:MM"
                                  )}
                                  ,
                                </strong>
                                <span>
                                  {dateFormat(
                                    detailsModal.flightSegments[0]
                                      .departureDateTime,
                                    "dd mmm (ddd)"
                                  )}
                                </span>
                              </p>
                            </Col>
                            <Col span={8} className="more-details-line"></Col>
                            <Col span={8} className="more-details-list">
                              <p>
                                {
                                  detailsModal.flightSegments[
                                    detailsModal.flightSegments.length - 1
                                  ].destination
                                }
                              </p>
                              <p>
                                <strong>
                                  {dateFormat(
                                    detailsModal.flightSegments[
                                      detailsModal.flightSegments.length - 1
                                    ].arrivalDateTime,
                                    "HH:MM"
                                  )}
                                  ,
                                </strong>
                                <span>
                                  {dateFormat(
                                    detailsModal.flightSegments[
                                      detailsModal.flightSegments.length - 1
                                    ].arrivalDateTime,
                                    "dd mmm (ddd)"
                                  )}
                                </span>
                              </p>
                            </Col>
                          </Row>
                        </Col>
                        <Col span={6} className="trip-duration-time">
                          <p>Total trip duration:</p>
                          <p>
                            {detailsModal.flightSegments.length > 0
                              ? calculateDuration(
                                  detailsModal.flightSegments[0]
                                    .departureDateTime,
                                  detailsModal.flightSegments[
                                    detailsModal.flightSegments.length - 1
                                  ].arrivalDateTime
                                )
                              : calculateDuration(
                                  detailsModal.flightSegments[0]
                                    .departureDateTime,
                                  detailsModal.flightSegments[0].arrivalDateTime
                                )}{" "}
                            |
                            {detailsModal.flightSegments.length === 0 ? (
                              <>Direct</>
                            ) : (
                              <>
                                {detailsModal.flightSegments.length - 1} stops{" "}
                              </>
                            )}
                          </p>
                        </Col>
                        <Col span={4} className="trip-duration-time">
                          <p>class:</p>
                          <p>Economy</p>
                        </Col>
                      </Row>
                    </div>

                    {detailsModal.flightSegments.map((flightSegment) => (
                      <div className="total-flight-details">
                        <div className="to-fro-flight-details">
                          <div className="from-city-flight-details">
                            <span>{flightSegment.origin}</span>
                          </div>
                          <div>
                            <span>
                              departure:{" "}
                              <strong>
                                {dateFormat(
                                  flightSegment.departureDateTime,
                                  "HH:MM"
                                )}
                                ,
                              </strong>
                            </span>
                            <span>
                              {dateFormat(
                                flightSegment.departureDateTime,
                                "dd mmm (ddd)"
                              )}
                            </span>
                          </div>
                        </div>
                        <div className="collapsed-card"></div>
                        <div className="to-fro-flight-details">
                          <div className="from-city-flight-details">
                            <span>{flightSegment.destination}</span>
                          </div>
                          <div>
                            <span>
                              arrival:
                              <strong>
                                {formatFlightTime(
                                  flightSegment.arrivalDateTime
                                )}
                              </strong>
                            </span>
                            <span>
                              {dateFormat(
                                flightSegment.arrivalDateTime,
                                "dd mmm (ddd)"
                              )}
                            </span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </TabPane>
                ) : null}
              </Tabs>
            </div>
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default Flightticketsuccess;
